(function (appComponents) {

	appComponents.services.panda = function (Components) {

		var panda = {};

		panda.name = "panda";

		Components.getComponentPrototype().extend(panda);

		panda._modals = panda._getService("modals");
		panda._b2bUnit = panda._getService("b2bUnit");
		panda._helpers = panda._getService("helpers");

		panda.selectedProduct = null;

		panda.elements = {
			get feedbackModal() {
				return $('[pc-container="panda--feedback-modal"]');
			},
			get detailsModal() {
				return $('[pc-container="panda--details-modal"]');
			},
			get detailsBody() {
				return $('[pc-container="panda--details-body"]');
			}
		};

		panda.bindings = function () {

			$(document).on("submit", "form[pc-container='panda--feedback-form']", function () {
				panda.handlers.onFeedbackFormSubmit(this);
				return false;
			});
		};

		panda.showFeedback = function () {
			panda.elements.feedbackModal.modal("show");
		};

		panda.initFeedback = function (product) {
			panda.selectedProduct = product;
			panda.showFeedback();
		};

		panda.formatEntity = function (entity) {
			var objectToReturn = {};
			if (entity.entryNumber != null) {
				// entry with panda
				objectToReturn.modelNo = entity.product.code;
				objectToReturn.warehouses = entity.warehouseDetails;
				objectToReturn.replenishments = entity.replenishmentDetails;
			} else {
				// product with panda
				objectToReturn.modelNo = entity._panda.prodNum;
				objectToReturn.warehouses = entity._panda.availabilityList;
				objectToReturn.replenishments = entity._panda.replNoteList;
			}
			return objectToReturn;
		};

		panda.showDetails = function (entity) {
			var pandaObj = panda.formatEntity(entity);
			var context = {
				panda: pandaObj
			};
			var html = panda.templates.paDetails(context);
			panda.elements.detailsBody.html(html);
			panda.elements.detailsModal.modal("show");
		};

		panda.checkPriceAndAvailability = function (paDataArray, isCartRequest) {

			var paData = {
				products: paDataArray,
				b2bUnitId: panda._b2bUnit.currentUnit.uid
			};

			return panda._api.panda.checkPriceAndAvailability(paData, isCartRequest).then(function (res) {
				if (res && res.status == 200) {
					return res.body;
				} else {
					// global response error
					// panda.handleErrors()
					console.log(res);
				}
			});
		};

		panda.handlers = {

			onFeedbackFormSubmit: function (el) {
				var hasErrors = panda._helpers.checkFormForErrors(el);
				if (hasErrors) {
					return;
				}

				var formData = panda._utils.getFormData(el);

				formData.product = panda.selectedProduct;
				formData.selectedIndex = panda._b2bUnit.currentUnit.uid;

				panda._api.panda.sendFeedback(formData).then(function (res) {

					panda.elements.feedbackModal.modal("hide");

					if (res && res.status == 200) {
						panda._modals.success.show(panda._messages.feedbackSuccess);
					} else {
						panda._modals.warning.show(panda._messages.feedbackError);
					}

				});

			},

		};

		panda.init = function () {

			panda._bindings();

		};

		return panda;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});